import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { ReactElement } from "react";
import { EventNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { HubDetailsDialog } from "client/Features/Hub/HubDetailsDialog";

export type EventActivityInvocationProps = {
	data: EventNotificationDataViewModel;
	onDismiss: () => void;
};

export const EventActivityInvocation = (props: EventActivityInvocationProps): ReactElement => {
	const {
		data,
		onDismiss
	} = props;

	const {
		eventId
	} = data;

	return (
		<HubDetailsDialog
			itemKind={HubItemKind.Event}
			id={eventId}
			onClose={onDismiss}
		/>
	);
};

EventActivityInvocation.displayName = "EventActivityInvocation";